import Layout from '../../components/feature/Layout';
import Auditorias from '../home/components/Auditorias';
import SEO from '../../components/feature/SEO';

const auditoriasJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Auditorías HSE',
  provider: {
    '@type': 'Organization',
    name: 'SafeLine Solutions',
    url: `${import.meta.env.VITE_SITE_URL ?? ''}`,
  },
  url: `${import.meta.env.VITE_SITE_URL ?? ''}/auditorias`,
  description: 'Realizamos auditorías HSE integrales para diagnosticar el estado de seguridad de tu empresa. Identificamos brechas y proponemos mejoras concretas basadas en normativas vigentes.',
  areaServed: {
    '@type': 'Place',
    name: 'Latinoamérica',
  },
  serviceType: 'Auditorías de Seguridad HSE',
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Inicio', item: `${import.meta.env.VITE_SITE_URL ?? ''}/` },
      { '@type': 'ListItem', position: 2, name: 'Servicios', item: `${import.meta.env.VITE_SITE_URL ?? ''}/servicios` },
      { '@type': 'ListItem', position: 3, name: 'Auditorías HSE', item: `${import.meta.env.VITE_SITE_URL ?? ''}/auditorias` },
    ],
  },
};

export default function AuditoriasPage() {
  return (
    <Layout>
      <SEO
        title="Auditorías HSE | SafeLine Solutions - Diagnóstico de Seguridad"
        description="Realizamos auditorías HSE integrales para diagnosticar el estado de seguridad de tu empresa. Identificamos brechas y proponemos mejoras concretas basadas en normativas vigentes."
        keywords="auditorías HSE, diagnóstico seguridad, auditoría seguridad empresas, cumplimiento normativo HSE"
        canonical="/auditorias"
        jsonLd={auditoriasJsonLd}
      />
      <div className="pt-20">
        <Auditorias />
      </div>
    </Layout>
  );
}
